/**
 * Der lokale Kalendertag als `YYYY-MM-DD`.
 *
 * NICHT `new Date().toISOString().slice(0, 10)`: das ist UTC. Oestlich von
 * Greenwich steht dort abends schon der Folgetag, westlich davon morgens noch
 * der Vortag — ein Beleg gilt dann einen Tag zu frueh oder zu spaet als
 * faellig. Gerechnet wird deshalb mit dem Zonenversatz vom Uhrzeitpunkt
 * selbst (Sommer-/Winterzeit steckt darin), und erst das verschobene Datum
 * wird als ISO-Zeichenkette abgeschnitten.
 */
export const localToday = (): string => {
    const d = new Date();
    const off = d.getTimezoneOffset();
    return new Date(d.getTime() - off * 60_000).toISOString().slice(0, 10);
};
